import React from 'react';
import { Button } from 'aha-components';
import Drawer from '@material-ui/core/Drawer';
import { useTranslation } from 'react-i18next';

import { ReactComponent as CloseIcon } from '@/assets/icons/close.svg';

import styles from './bottomDrawer.module.less';
import '@/components/campaign/custom.less';

interface Props {
  children: any;
  width?: number;
  title?: string | React.ReactNode;
  isShowHeader?: boolean;
  isShowFooter?: boolean;
  visible: boolean;
  submitDisabled?: boolean;
  isLoading?: boolean;
  rootClassName?: string;
  rootStyle?: React.CSSProperties;
  className?: string;
  handleClose?: () => void;
  handleSubmit?: () => void;
  okText?: string;
  // cancelText?: string;
  keepMounted?: boolean;
  isShowBack?: boolean;
  handleBack?: () => void;
}

const BottomDrawer: React.FC<Props> = ({
  children,
  title,
  visible,
  isShowHeader = true,
  isShowFooter = true,
  submitDisabled,
  isLoading,
  rootClassName,
  rootStyle,
  className,
  handleClose,
  handleSubmit,
  okText,
  // cancelText = 'Cancel',
  keepMounted = false,
  isShowBack = false,
  handleBack = () => {}
}) => {
  const { t } = useTranslation();

  okText = okText || t('common.modal.submit_btn', { defaultValue: 'Submit' });

  return (
    <Drawer
      id="drawerCtn"
      anchor="bottom"
      open={visible}
      onClose={handleClose}
      keepMounted={keepMounted}
      classes={{
        root: rootClassName,
        paper: className + ' !max-h-[calc(100%-200px)]'
      }}
      style={{ ...rootStyle }}
    >
      {isShowHeader && (
        <div className={styles.header}>
          <div className={styles.title}>{title}</div>
          <div className={styles.close} onClick={handleClose}>
            <CloseIcon />
          </div>
        </div>
      )}
      {children}
      {isShowFooter && (
        <div className={styles.footer}>
          <Button className="!h-[34px]" onClick={handleClose}>
            {t('common.drawer.cancel_btn', { defaultValue: 'Cancel' })}
          </Button>
          {isShowBack && (
            <Button className="!h-[34px]" onClick={handleBack}>
              {t('common.modal.back_btn')}
            </Button>
          )}
          <Button
            disabled={submitDisabled || isLoading}
            className="!h-[34px]"
            type="primary"
            loading={isLoading}
            onClick={handleSubmit}
          >
            {okText ? (
              okText
            ) : (
              <span>
                {isLoading
                  ? t('common.drawer.submitting_btn', {
                      defaultValue: 'Submitting'
                    })
                  : t('common.drawer.submit_btn', { defaultValue: 'Submit' })}
              </span>
            )}
          </Button>
        </div>
      )}
    </Drawer>
  );
};

export default BottomDrawer;
